<template>
  <div class="join">
    <!-- <img
      class="join__bg"
      src="../assets/bg.png">
    <input-phone-dialog
      v-show="pageLoad"
      v-if="!inGroup"
      class="join__phone"
      :class="!isHeader && 'join__grouper'"
      @receive="receive">
        <img
          v-if="showClose && !isHeader"
          class="join__close"
          src="../assets/close.png"
          @click="close"/>
    </input-phone-dialog>
    <invite-dialog
      :num="num"
      :headerName="headerName"
      v-else
      class="join__invite"
      @invite="invite">
      <img
        v-if="showClose"
        class="join__close"
        src="../assets/close.png"
        @click="close">
      </invite-dialog>
    <img
      v-show="showShare"
      @click="showShare = false"
      class="share"
      src="../assets/activity.png">
    <div
      v-if="!isHeader"
      class="mask"></div> -->
  </div>
</template>

<script>
// import InputPhoneDialog from '../components/InputPhoneDialog'
// import inviteDialog from '../components/inviteDialog'
// import API from '../service/api'
// import getRedPackedList from '../lib/redPacketAlgorithm'
// import { setShare } from '../lib/wx'

export default {
  components: {
    // InputPhoneDialog,
    // inviteDialog
  },
  data () {
    return {
      num: 1,
      headerName: '',
      isHeader: true,
      inGroup: false,
      showClose: false,
      showShare: false,
      saving: false,
      invalid: false,
      pageLoad: false
    }
  },
  async mounted () {
    // alert(JSON.stringify(this.$route.query))
    this.$nextTick(() => {
      // this.pageLoad = true
    })
    this.load()
  },
  methods: {
    load () {
      const query = this.$route.query
      const groupId = query.groupId
      this.init(groupId)
    },
    async init (groupId) {
      let user = await this.getUser()
      if (user) { // 已经存在
        if (user.isHeader) {
          this.$router.replace({
            name: 'InviteGrouper',
            query: {
              groupId: user.groupId
            }
          })
          return
        }
        this.inGroup = true
        // this.isHeader = false
        // this.showClose = true
        // return
      // } else {
      //   this.pageLoad = true
      //   this.$message('您来晚啦，活动已经结束！')
      //   return
      }
      // 检查groupId
      if ((groupId && groupId !== 'undefined') || user) {
        let isContinue = await this.groupValidate((user && user.groupId) || groupId)
        this.pageLoad = true
        if (!isContinue) return
        if (!user && this.num <= 0) { // 满了
          this.$message('您来晚啦，团员已经满了，您将会重新开团！')
          this.$router.replace({
            name: 'JoinGroup',
            query: {}
          })
          this.isHeader = true
          return
        }
        if (this.remindTime < 0) { // 时间已过
          if ((user && this.num > 0) || !user) {
            if (user) { // 删除
              // API.deleteUser(this, {
              //   openid: sessionStorage.openid
              // })
            }
            // this.$message('您来晚啦，成团时间已过，您将会重新开团！')
            this.$message('您来晚啦，成团时间已过，活动已经结束！')
            this.$router.replace({
              name: 'JoinGroup',
              query: {}
            })
            this.isHeader = true
            this.inGroup = false
            this.showClose = false
            return
          }
        }

        if (user && this.num === 0) {
          this.$router.replace({
            name: 'InviteGrouper',
            query: {
              groupId: user.groupId
            }
          })
        }
        if (this.num === 6) { // 无效groupId
          this.isHeader = true
          this.inGroup = false
          return
        }
        this.isHeader = false
        this.showClose = true
        return
      }
      // 不存在，新开团
      this.pageLoad = true
      this.isHeader = true
    },
    // async groupValidate (groupId) {
    //   return API.getList(this, {
    //     groupId
    //   }).then(res => {
    //     let data = res.data
    //     this.num = 6 - data.length
    //     let header = data.find(item => item.isHeader === 1)
    //     if (header) {
    //       this.remindTime = new Date(header.createTime).getTime() + 24 * 60 * 60 * 1000 - Date.now()
    //       this.headerName = header.name
    //     }
    //     /// ///////////
    //     if (this.num < 0) { // 超了
    //       let userIndex = data.findIndex(item => item.openid === sessionStorage.openid)
    //       if (userIndex >= 6) { // 删
    //         API.deleteUser(this, {
    //           openid: sessionStorage.openid,
    //           delete: true
    //         })
    //         this.$message('您来晚啦，团员已经满了，您将会重新开团！')
    //         this.$router.replace({
    //           name: 'JoinGroup',
    //           query: {}
    //         })
    //         this.inGroup = false
    //         this.isHeader = true
    //       }
    //       return false
    //     }
    //     /// ///////////
    //     return true
    //   }).catch(res => {})
    // },
    async getUser () {
      if (!sessionStorage.openid) return
      // let res = await API.getUser(this, {
      //   openid: sessionStorage.openid
      // })
      // return res && res.data
    },
    // receive (num) {
    //   if (this.saving) return
    //   this.saving = true
    //   let user = {
    //     phoneNum: num,
    //     isHeader: this.isHeader,
    //     name: localStorage.name,
    //     openid: sessionStorage.openid,
    //     avatarUrl: localStorage.avatarUrl
    //   }
    //   if (this.isHeader) {
    //     // alert(sessionStorage.openid)
    //     user.groupId = sessionStorage.openid.substr(0, 20) + parseInt(new Date().getTime() / 1000) // 生成唯一的
    //   } else {
    //     user.groupId = this.$route.query.groupId
    //   }

    //   API.saveUser(this, user)
    //     .then(async data => {
    //       if (!data.data) { // 保存失败
    //         this.$message(data.msg || '领取失败')
    //         return
    //       }
    //       setShare(user.groupId)
    //       await this.groupValidate(user.groupId)
    //       if (this.isHeader || this.num === 0) {
    //         this.$router.replace({
    //           name: 'InviteGrouper',
    //           query: {
    //             groupId: user.groupId
    //           }
    //         })
    //         return
    //       }
    //       this.inGroup = true
    //       this.showClose = true
    //       // this.$router.replace({
    //       //   name:'JoinGroup',
    //       //   query: {
    //       //     groupId: user.groupId
    //       //   }
    //       // })
    //     }).catch(err => {
    //       if (err.errCode === 101) {
    //         this.groupId = null
    //         this.isHeader = true
    //         this.showClose = false
    //       }
    //     }).finally(() => {
    //       this.saving = false
    //     })
    // },
    invite () {
      this.showShare = true
    },
    close () {
      if (this.inGroup) {
        this.$router.replace({
          name: 'InviteGrouper',
          query: {
            groupId: this.$route.query.groupId
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/JoinGroup.vue